import React, { useEffect } from "react";
import { useState } from "react";
import { CiViewList } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { useInfluencer } from "../../../../Providers/Influencer";
import { toast } from "react-toastify";
import { Input } from "@/shadcnComponents/ui/input";
import { Button } from "@/shadcnComponents/ui/button";
import mixpanel from "mixpanel-browser";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

export interface WishlistProps {
  companyName: string;
  companyUrl: string;
}

export const Company_list: React.FC = () => {
  const navigate = useNavigate();
  const influencerState = useInfluencer();

  const [data, setData] = useState<WishlistProps[]>([
    {
      companyName: "",
      companyUrl: "",
    },
  ]);

  useEffect(() => {
    mixpanel.track("Visited Brand Wishlist Page");
  }, []);

  const addCompanyList = () => {
    setData([
      ...data,
      {
        companyName: "",
        companyUrl: "",
      },
    ]);
  };

  const handleChangeData = (value: string, index: number, field: string) => {
    setData((prevData) => {
      const newArray = [...prevData];
      const updatedObj = newArray[index];
      updatedObj[field] = value;
      newArray[index] = updatedObj;
      return newArray;
    });
  };

  const handleSubmit = async () => {
    let isError = false;
    try {
      data.map((item) => {
        if (!item.companyName) {
          isError = true;
          return toast.error("Please fill Company Name", { autoClose: 1500 });
        }
        if (!item.companyUrl) {
          isError = true;
          return toast.error("Please fill Company URL", { autoClose: 1500 });
        }
      });
      if (!isError) {
        const result = await influencerState?.updateWishlist(data);
        if (result?.success) {
          setData([
            {
              companyName: "",
              companyUrl: "",
            },
          ]);
          toast.success("WishList saved", { autoClose: 1500 });
        } else {
          toast.error("Some Error Occurred, Please try again!", {
            autoClose: 1500,
          });
        }
      }
    } catch (error) {
      toast.error("Some Error Occurred, Please try again!", {
        autoClose: 1500,
      });
    }
  };

  return (
    <>
      <MobileMenuBar />
      <div className="flex justify-center items-center w-full h-full font-inter">
        <div className="flex flex-col gap-5 w-full h-full p-10">
          <div className="flex justify-between flex-col md:flex-row gap-3 items-end">
            <div className="w-full flex flex-col gap-2 text-white  not-italic font-semibold leading-[normal] ">
              <h1 className="text-sm md:text-base">
                Dream Brands? Craft Your Collab Wish List
              </h1>
              <h3 className="text-[#a3a3a3] text-xs md:text-sm font-[400]">
                We can't guarantee every dream collab, but your wishlist fuels
                our search!
              </h3>
            </div>
            <Button
              variant="destructive"
              className="text-xs md:text-sm"
              onClick={() => {
                mixpanel.track("View Brand List Clicked");
                navigate("/influencer/view_brands_list");
              }}
            >
              <CiViewList size={20} /> View Brand List
            </Button>
          </div>
          <div className="flex md:w-[55%] flex-col items-start gap-5 p-5 bg-[color:var(--Natural-900,#212121)] rounded-lg w-full">
            {data?.map((item, index) => {
              return (
                <div key={index} className="grid grid-cols-2 gap-5">
                  <Input
                    className="@apply bg-transparent placeholder:text-[#A3A3A3] rounded border border-[color:var(--Natural-800,#424242)] px-4 py-3 border-solid overflow-hidden text-[color:var(--Natural-600,#757575)] text-ellipsis text-xs not-italic font-normal leading-[normal]"
                    placeholder="Name"
                    value={item.companyName}
                    onChange={(e) =>
                      handleChangeData(e.target.value, index, e.target.name)
                    }
                    name="companyName"
                    id="companyName"
                  />
                  <Input
                    className="@apply bg-transparent placeholder:text-[#A3A3A3] rounded border border-[color:var(--Natural-800,#424242)] px-4 py-3 border-solid overflow-hidden text-[color:var(--Natural-600,#757575)] text-ellipsis text-xs not-italic font-normal leading-[normal]"
                    placeholder="Website URL"
                    value={item.companyUrl}
                    onChange={(e) =>
                      handleChangeData(e.target.value, index, e.target.name)
                    }
                    name="companyUrl"
                    id="companyUrl"
                  />
                </div>
              );
            })}

            <Button
              variant="ghost"
              onClick={() => {
                mixpanel.track("Add More Company Clicked");
                addCompanyList();
              }}
              className="text-[#bdbdbd]"
            >
              + Add More Company
            </Button>
          </div>
          <div className="w-full md:w-[55%] justify-end flex">
            <Button
              variant="destructive"
              onClick={() => {
                mixpanel.track("Submit Wishlist Clicked");
                handleSubmit();
              }}
            >
              Submit →
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
